module.exports = __webpack_public_path__ + "img/doubleCheck.ce37dc90.jpg";